import { Box, Button, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import { useMissionsList } from './missions-list.hook';
import CNLoading from 'src/components/loading-cn/CNLoading';
import TableRox from 'src/components/table-rox/TableRox';
import { paths } from 'src/routes/paths';
import { useMyDataStore } from 'src/store/me/me.store';

export default function MissionsList() {
  const hook = useMissionsList();

  const permissions = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.missions)

  return (
    <Page title="Missões">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          links={[]}
          heading="Missões"
          action={
            <Button variant="contained" onClick={() => hook.navigate(paths.dashboard.missionCreate)} disabled={!permissions?.create}>
              Cadastrar Missão
            </Button>
          }
        />
        {hook.isLoadingMissionsList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            data={hook.missionsList}
            header={hook.TABLEHEADER}
            defaultOrderBy="name"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => hook.navigate(paths.dashboard.missionDetails(id))}
            selectKey="_id"
          />
        )}
      </Container>
    </Page>
  );
}
